import { GRID_DATA_LIMIT } from '../../constants';

// Round (index+1) up to the next GRID_DATA_LIMIT chunk so the customLimit
// refetch returns a payload that contains the target row. Clamp to total so
// we never request more rows than the dataset actually has.
export const computeCustomLocateLimit = (
  index: number,
  total?: number
): number => {
  const chunked = Math.ceil((index + 1) / GRID_DATA_LIMIT) * GRID_DATA_LIMIT;
  return total === undefined ? chunked : Math.min(chunked, total);
};
